// Helpers + state management for visitor gallery
import { visitorAdjectives, visitorNouns } from './mockData';

const LS_KEY = 'manisha_visitors_v2';

export const HATS = [
  { name: 'Sprout', emoji: '🌱' },
  { name: 'Party', emoji: '🎉' },
  { name: 'Cap', emoji: '🧢' },
  { name: 'Bucket', emoji: '🪣' },
  { name: 'Top Hat', emoji: '🎩' },
];

export const COLORS = [
  { name: 'Pink', value: '#bf5a7a', soft: '#fce8e8' },
  { name: 'Orange', value: '#cb7836', soft: '#fce8d4' },
  { name: 'Teal', value: '#168b9d', soft: '#d4ecec' },
  { name: 'Green', value: '#1a7b3f', soft: '#e0f0d4' },
];

export const ASCII_VARIANTS = [
  // Cat
  `   /\\___/\\
  (  o   o  )
  =  >   <  =
   (  "  "  )
  /          \\
 |  |    |  |
  \\__|__|__/`,
  // Spirit / Totoro-like
  `      .---.
    .'     '.
   /  o   o  \\
  |    ^      |
   \\   ___  /
    '.____.'
     /    \\
    |  __  |
     \\____/`,
  // Star sparkle
  `       *
     *   *
   .  '*' .
  '. .*. .'
     '*'
      *`,
  // Mushroom
  `    .-""""-.
   /  o  o  \\
  |  \\__/   |
   '.______.'
      ||||
      ||||
      ||||`,
  // Bunny
  `   (\\___/)
   ( o.o )
   (>   <)
   /     \\
  (_______)`,
];

export function generateVisitorName() {
  const adj = visitorAdjectives[Math.floor(Math.random() * visitorAdjectives.length)];
  const noun = visitorNouns[Math.floor(Math.random() * visitorNouns.length)];
  return `${adj} ${noun}`;
}

export function loadVisitors() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) return JSON.parse(raw);
  } catch (_e) {}
  return seedVisitors();
}

export function saveVisitors(visitors) {
  localStorage.setItem(LS_KEY, JSON.stringify(visitors));
}

export function addVisitor(v) {
  const visitors = loadVisitors();
  const next = [v, ...visitors];
  saveVisitors(next);
  return next;
}

export function deleteVisitor(id) {
  const visitors = loadVisitors().filter(v => v.id !== id);
  saveVisitors(visitors);
  return visitors;
}

export function updateVisitor(id, patch) {
  const visitors = loadVisitors().map(v => v.id === id ? { ...v, ...patch } : v);
  saveVisitors(visitors);
  return visitors;
}

function seedVisitors() {
  const now = Date.now();
  const arr = Array.from({ length: 24 }).map((_, i) => {
    const colorIdx = Math.floor(Math.random() * COLORS.length);
    const hatIdx = Math.floor(Math.random() * HATS.length);
    return {
      id: 5313 - i,
      name: generateVisitorName(),
      hat: HATS[hatIdx].name,
      color: COLORS[colorIdx].name,
      colorValue: COLORS[colorIdx].value,
      variant: i % ASCII_VARIANTS.length,
      signed: Math.random() > 0.45,
      signature: null,
      createdAt: now - (i + 1) * 1000 * 60 * (15 + Math.random() * 60 * 5),
    };
  });
  saveVisitors(arr);
  return arr;
}

export function computeStats(visitors) {
  if (!visitors.length) return { signedPct: 0, colorPicks: [], hatCounts: [], latestRel: 'never', totalCount: 0 };
  const total = visitors.length;
  const signedPct = Math.round((visitors.filter(v => v.signed).length / total) * 100);

  const colorMap = {};
  COLORS.forEach(c => { colorMap[c.name] = 0; });
  visitors.forEach(v => { if (colorMap[v.color] !== undefined) colorMap[v.color] += 1; });
  const colorPicks = COLORS.map(c => ({
    name: c.name,
    color: c.value,
    pct: Math.round((colorMap[c.name] / total) * 100),
    count: colorMap[c.name],
  })).sort((a, b) => b.count - a.count);

  const hatMap = {};
  HATS.forEach(h => { hatMap[h.name] = 0; });
  visitors.forEach(v => { if (hatMap[v.hat] !== undefined) hatMap[v.hat] += 1; });
  const hatCounts = HATS.map(h => ({ name: h.name, count: hatMap[h.name], emoji: h.emoji }))
    .sort((a, b) => b.count - a.count);

  const latest = visitors[0];
  const diff = Date.now() - (latest.createdAt || Date.now());
  const mins = Math.floor(diff / 60000);
  let latestRel = 'just now';
  if (mins >= 1 && mins < 60) latestRel = `${mins}m ago`;
  else if (mins >= 60 && mins < 60 * 24) latestRel = `${Math.floor(mins / 60)}h ago`;
  else if (mins >= 60 * 24) latestRel = `${Math.floor(mins / 60 / 24)}d ago`;

  return { signedPct, colorPicks, hatCounts, latestRel, totalCount: total };
}

export function formatDate(ts) {
  const d = new Date(ts);
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yy = String(d.getFullYear()).slice(2);
  return `${mm}/${dd}/${yy}`;
}
